import {
    Box,
    Button,
    Grid,
    IconButton,
    Skeleton,
    Theme,
    Typography,
} from "@mui/material";
import {
    DebtIcon,
    FiveStarRatingIcon,
    FlexiCapIcon,
    GoalCalculatorIcon,
    HybridIcon,
    LargeCapIcon,
    MidCapIcon,
    MultiAssetIcon,
    MultiCapIcon,
    NFOIcon,
    SectoralIcon,
    SIPCalculatorIcon,
    SmallCapIcon,
} from "../../../assets/SvgIcons";
import {
    navigationData,
} from "../types";
import {
    useDispatch,
    useSelector
} from "react-redux";
import {
    useEffect,
    useState,
} from "react";
import { useHistory } from "react-router";
import { RootStateType } from "../../../redux-store/reducers";
import BreadCrum from "../../../lib/BreadCrum";

import PopularFundsCard from "./PopularFundsCard";
import CategoryCard from "./CategoryCard";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GetPopularFundsRes } from "../../../redux-store/types/investorProfile";
import { getExploreMFCategories, getPopularFunds, setAppliedFundsFilters, setSelectedSchemesObj } from "../../../redux-store/actions/investorProfile";
import SIPCalculatorCard from "./SIPCalculatorCard";
import GoalCalculatorCard from "./GoalCalculatorCard";
import { isModuleAllowed } from "../../../utils/utilityFunctions";
import { USER_ROLES } from "../../../utils/constant";





export default function ExploreMutualFund(): JSX.Element {
    const history = useHistory();
    const dispatch = useDispatch();
    const { pathname: pathName, state } = history.location
    const { clientCode = '' } = state as navigationData

    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio,
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const [isFiltersLoading, setFiltersLoading] = useState<boolean>(false)
    const [isSchemesTableDataLoading, setSchemesTableDataLoading] = useState<boolean>(false)
    const [isSearchSchemesDialogVisible, setSearchSchemesDialogVisible] = useState<boolean>(false)
    const [popularFundsLoading, setPopularFundsLoading] = useState<boolean>(false);
    const [popularFunds, setPopularFunds] = useState<GetPopularFundsRes>({} as GetPopularFundsRes);
    const [categories, setCategories] = useState<any>([]);
    const [isCategoriesLoading, setCategoriesLoading] = useState<boolean>(false);
    const [viewMore, setViewMore] = useState<boolean>(false);




    const handleSearchMutualFundsClick = () => {
        if (!isFiltersLoading && !isSchemesTableDataLoading) {
            setSearchSchemesDialogVisible(true)
        }
    }
    const handleSearchSchemesDialogClose = () => {
        setSearchSchemesDialogVisible(false)
    }

    const handleSearchSchemesDialogProceedClick = async () => {
        try {
            setSearchSchemesDialogVisible(false)
            setSchemesTableDataLoading(true)
        } catch (e) {
            console.log("Error: ", e)
        } finally {
            setSchemesTableDataLoading(false)
        }
    }





    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? ` (${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            }
        },
        {
            name: 'Explore Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode
            }
        },
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? ` (${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            }
        },
        {
            name: 'Explore Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            }
        },
    ]

    const CATEGORIES = [
        {
            icon: <FiveStarRatingIcon />,
            label: "5 Star Rating Funds",
            key: 'rating',
            value: {
                label: "5 Stars",
                value: "5",
                filterType: "rating",
                filterTypeValue: "rating-5",
                ratingId: "5",
                ratingName: "5 Stars"
            }
        },
        {
            icon: <LargeCapIcon />,
            label: "Large Cap",
            key: 'subCategory',
            value: {
                label: "Equity: Large Cap",
                value: "100",
                filterType: "category",
                filterTypeValue: "category-100",
                categoryId: "1",
                categoryName: "Equity",
                subCategoryId: "100",
                subCategoryName: "Equity: Large Cap",
            }
        },
        {
            icon: <FlexiCapIcon />,
            label: "Flexi Cap",
            key: 'subCategory',
            value: {
                label: "Equity: Flexi Cap",
                value: "102",
                filterType: "category",
                filterTypeValue: "category-102",
                categoryId: "1",
                categoryName: "Equity",
                subCategoryId: "102",
                subCategoryName: "Equity: Flexi Cap",
            }
        },
        {
            icon: <MidCapIcon />,
            label: "Mid Cap",
            value: {
                label: "Equity: Mid Cap",
                value: "103",
                filterType: "category",
                filterTypeValue: "category-,103",
                categoryId: "1",
                categoryName: "Equity",
                subCategoryId: "103",
                subCategoryName: "Equity: Mid Cap",
            }
        },
        {
            icon: <SmallCapIcon />,
            label: "Small Cap",
            value: {
                label: "Equity: Small Cap",
                value: "104",
                filterType: "category",
                filterTypeValue: "category-104",
                categoryId: "1",
                categoryName: "Equity",
                subCategoryId: "104",
                subCategoryName: "Equity: Small Cap"
            }
        },
        {
            icon: <HybridIcon />,
            label: "Hybrid",
            key: 'category',
            value: {
                label: "Hybrid",
                value: "hybrid_all",
                filterType: "category",
                filterTypeValue: "category-hybrid_all",
                categoryId: "3",
                categoryNamw: "Hybrid",
                subCategoryId: "hybrid_all",
                subCategoryName: "Hybrid"
            }
        },
        {
            icon: <NFOIcon />,
            label: "NFO"
        },
        {
            icon: <DebtIcon />,
            label: "Debt",
            key: 'category',
            value: {
                label: "Debt",
                value: "debt_all",
                filterType: "category",
                filterTypeValue: "category-debt_all",
                categoryId: "2",
                categoryName: "Debt",
                subCategoryId: "debt_all",
                subCategoryName: "Debt"
            }
        },
        {
            icon: <DebtIcon />,
            label: "Commodities",
            value: {
                label: "Commodities",
                value: "commodities_all",
                filterType: "category",
                filterTypeValue: "category-commodities_all",
                categoryId: "4",
                categoryName: "Commodities",
                subCategoryId: "commodities_all",
                subCategoryName: "Commodities"
            }
        },
        {
            icon: <MultiCapIcon />,
            label: "Multi-Cap",
            value: {
                label: "Commodities",
                value: "commodities_all",
                filterType: "category",
                filterTypeValue: "category-commodities_all",
                categoryId: "4",
                categoryName: "Commodities",
                subCategoryId: "commodities_all",
                subCategoryName: "Commodities"
            }
        },
        {
            icon: <MultiAssetIcon />,
            label: "Multi-Asset"
        },
        {
            icon: <SectoralIcon />,
            label: "Sectoral"
        },

    ]

    const CALCULATORS = [
        {
            icon: <SIPCalculatorIcon />,
            label: "SIP Calculator",
            path: `/calculator`
        },
        {
            icon: <GoalCalculatorIcon />,
            label: "Goal Calculator",
            path: `/nfo-calculator`
        }
    ]

    const handleViewMoreClick = () => {
        setViewMore((prev) => !prev);
    }

    const normalizeAllKey = (name: string) =>
        name.trim().toLowerCase().replace(/\s+/g, "_");

    const mapCategories = (arr: any) => {
        return arr.map((item: any) => {
            const { categoryId, categoryName, subCategoryId, subCategoryName, icon } = item;
            // Rating
            if (categoryId === "-1") {
                return {
                    icon,
                    label: categoryName,
                    value: {
                        label: "5 Stars",
                        value: "5",
                        filterType: "rating",
                        filterTypeValue: "rating-5",
                        ratingId: "5",
                        ratingName: "5 Stars",
                    },
                };
            }

            const hasSub =
                typeof subCategoryId === "string" &&
                subCategoryId.trim() !== "" &&
                typeof subCategoryName === "string" &&
                subCategoryName.trim() !== "";

            // Subcategory
            if (hasSub) {
                return {
                    icon,
                    label: subCategoryName,
                    value: {
                        label: subCategoryName,
                        value: subCategoryId,
                        filterType: "category",
                        filterTypeValue: `category-${subCategoryId}`,
                        categoryId,
                        categoryName,
                        subCategoryId,
                        subCategoryName,
                    },
                };
            }

            // Category
            const allKey = `${normalizeAllKey(categoryName)}_all`;
            return {
                icon,
                label: categoryName,
                value: {
                    label: categoryName,
                    value: allKey,
                    filterType: "category",
                    filterTypeValue: `category-${allKey}`,
                    categoryId,
                    categoryName,
                    subCategoryId: allKey,
                    subCategoryName: categoryName,
                },
            };
        });
    }

    const fetchPopularFunds = async () => {
        try {
            setPopularFundsLoading(true);
            const popularFunds = await (dispatch(getPopularFunds()) as unknown as Promise<GetPopularFundsRes>);
            setPopularFunds(popularFunds);
        } catch (e) {
            console.error('Error', e);
        }
        finally {
            setPopularFundsLoading(false);
        }
    }

    const fetchExploreMFCategories = async () => {
        try {
            setCategoriesLoading(true);
            const exploreMFCategories = await (dispatch(getExploreMFCategories()) as unknown as Promise<any>);
            const modifiedCategories = mapCategories(exploreMFCategories);
            setCategories(modifiedCategories);
        } catch (e) {
            console.error('Error', e);
        }
        finally {
            setCategoriesLoading(false);
        }
    }

    useEffect(() => {
        fetchExploreMFCategories();
        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));
    }, [])
    return (
        <>
            <Box>
                <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        marginTop: '4px'
                    }}
                >
                    <Typography
                        variant="h1"
                        sx={(theme: Theme) => ({ color: theme.palette.text.primary, mb: { xs: "10px", sm: "0px" } })}
                    >
                        Explore Mutual Funds
                    </Typography>
                    {/* <Box
                        sx={(theme: Theme) => ({
                            minWidth: { xs: '100%', sm: '300px' },
                            borderRadius: '57px',
                            height: '47.17px',
                            border: `1px solid ${theme.palette.text.secondary}B2`,
                            display: 'flex',
                            alignItems: 'center',
                            padding: '15px',
                            cursor: ((isFiltersLoading || isSchemesTableDataLoading) ? "not-allowed" : "pointer"),
                            opacity: ((isFiltersLoading || isSchemesTableDataLoading) ? 0.5 : 1)
                        })}
                        onClick={handleSearchMutualFundsClick}
                    >
                        <SearchIcon />
                        <Typography
                            sx={{
                                color: 'text.secondary',
                                paddingLeft: '10px',
                                cursor: ((isFiltersLoading || isSchemesTableDataLoading) ? "not-allowed" : "pointer")
                            }}
                            variant="subtitle_400">
                            Search for Mutual Funds...
                        </Typography>
                    </Box> */}
                </Box>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "25px",
                        backgroundColor: theme.palette.common.white,
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        padding: "20px",
                        [theme.breakpoints.up("sm")]: {
                            height: "calc(100vh - 180px)",
                            overflowY: "auto",
                            '&::-webkit-scrollbar': {
                                display: 'none'
                            }
                        }
                    })}
                >
                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography variant="body_600">
                                Popular Funds
                            </Typography>
                            <Typography variant="subtitle_500" color={'text.secondary'} mt={0.5}
                                width={{ xs: '80%', sm: 'auto' }}>
                                Explore top-performing schemes chosen by investors like you
                            </Typography>
                        </Box>
                        <Typography variant="body_500" sx={(theme: Theme) => ({
                            color: theme.palette.primary[500],
                            cursor: 'pointer'
                        })}
                            onClick={() => history.push(`${pathName}/selected-category-funds`, {
                                clientCode,
                            })}
                        >
                            All mutual funds
                        </Typography>
                    </Box> */}
                    {/* <Grid
                        container
                        mt={1}
                        spacing={2}
                        columns={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
                    >
                        {(popularFundsLoading
                            ? Array.from({ length: 5 }).map((_, i) => ({ __skeleton: true, id: `sk-${i}` }))
                            : (popularFunds?.currentPageFunds ?? [])
                        ).map((item: any, index: number) => (
                            <Grid
                                key={`fund-${index}`}
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={1}
                                xl={1}
                            >
                                {item?.__skeleton ? (
                                    <Skeleton variant="rectangular" height={150} sx={{ borderRadius: '20px' }} />
                                ) : (
                                    <PopularFundsCard data={item} clientCode={clientCode} />
                                )}
                            </Grid>
                        ))}
                    </Grid> */}

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box>
                            <Typography variant="h2"
                                sx={(theme: Theme) => ({
                                    ...theme.typography.body_600,
                                })}>
                                Categories
                            </Typography>
                            <Typography variant="subtitle_500" color={'text.secondary'} mt={0.5}>
                                Select a fund category to discover schemes that match your goals
                            </Typography>
                        </Box>

                        <Button
                            variant="contained"
                            onClick={() => history.push(`${pathName}/selected-category-funds`, {
                                clientCode,
                            })}
                            aria-label='explore-mutual-fund'
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                // width: { xs: '100%', sm: 'unset' },
                                borderRadius: { xs: "5px", sm: "10px" },
                                padding: { xs: "5px 10px", sm: "0px 15px" },
                                backgroundColor: theme.palette.primary[500],
                                color: theme.palette.textDark.primary,
                                "&.Mui-disabled": {
                                    backgroundColor: `${theme.palette.text.secondary}B2`,
                                    color: theme.palette.text.secondary,
                                    cursor: "not-allowed !important",
                                    pointerEvents: "auto"
                                }
                            })}
                        >
                            All mutual funds
                        </Button>
                    </Box>
                    <Grid container spacing={5} sx={{ mt: { xs: 0.5, sm: 2 } }} columnSpacing={2}>
                        <>
                            {isCategoriesLoading
                                &&
                                (
                                    Array.from({ length: 8 }).map((_, i) => (
                                        <Grid key={`skeleton-${i}`} item xs={12} sm={6} md={4} lg={3}>
                                            <Skeleton variant="rectangular" height={100} sx={{ borderRadius: '20px' }} />
                                        </Grid>
                                    ))
                                )}
                            {!isCategoriesLoading
                                &&
                                categories?.slice(0, viewMore ? categories?.length : 8)?.map((item: any, index: number) => (
                                    <Grid key={index} item xs={6} sm={6} md={4} lg={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <CategoryCard
                                            key={index}
                                            data={item}
                                        />
                                    </Grid>
                                ))}
                        </>
                    </Grid>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mt: 3,
                            gap: 0.5
                        }}
                    >
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.primary[500],
                                cursor: "pointer",
                            })}
                            onClick={handleViewMoreClick}
                        >
                            {viewMore ? "View Less" : "View More"}
                        </Typography>

                        <IconButton
                            sx={{
                                transform: viewMore ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "all 0.3s ease-in-out",
                                "&:hover": {
                                    backgroundColor: "unset",
                                },
                                p: 0.5,
                            }}
                            onClick={handleViewMoreClick}
                            aria-label="view-more-categories"
                        >
                            <ExpandMoreIcon
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[500],
                                    cursor: "pointer",
                                })}
                            />
                        </IconButton>
                        {/* {viewMore
                            ?
                            <ExpandLessIcon onClick={handleViewMoreClick} sx={(theme: Theme) => (
                                { color: theme.palette.customColors.hyperlinkBlue, cursor: 'pointer' }
                            )} />
                            :
                            <ExpandMoreIcon onClick={handleViewMoreClick} sx={(theme: Theme) => (
                                { color: theme.palette.customColors.hyperlinkBlue, cursor: 'pointer' }
                            )} />
                        } */}
                    </Box>


                    <Box sx={{ mt: 6 }}>
                        <Typography variant="body_600">
                            Tools & Calculators
                        </Typography>
                    </Box>

                    <Box sx={(theme: Theme) => ({ mt: 2, display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' })}>
                        <SIPCalculatorCard
                            data={CALCULATORS[0]}
                        />
                        <GoalCalculatorCard
                            data={CALCULATORS[1]}
                        />
                    </Box>
                </Box >
            </Box >
        </>
    )
}
